module.exports = __webpack_public_path__ + "static/media/GDb2Gj4asAABl4m.72d0df88.webp";